<template>
	<div>
		<div class="topbg flex flex-b">
			<div class="flex">
				<img src="../assets/images/home/logo.png" style="width: 133px;height: 27px;margin-right: 40px;" />
				<div class="flex">
					<div :class="tabIndex == index?'tabItemd':'tabItem'" @click="toPage(index)"
						class="flex flex-c-c pointer" v-for="(item,index) in tabs" :key="index">{{item}}</div>
				</div>
			</div>
			<div class="flex">
				<div class="znx pointer" @click="toUrl('/message')">
					<img src="../assets/images/home/ic_xiaoxi.png" style="width: 22px;height: 22px;" />
					<div class="red"></div>
				</div>
				<img :src="loginUser.img" v-if="loginUser"
					style="width: 44px;height: 44px;margin-left: 21px;border-radius: 5px;" />
				<el-dropdown v-if="loginUser" @command='logout'>
					<div class="pointer" @click="toUrl('/mine')" style="margin-left: 9px;">
						<div class="nickName">{{loginUser.name||loginUser.phone}}</div>
						<div class="flex" v-if="loginUser.member">
							<div class="vipbg flex flex-c-c">{{loginUser.member.name}}</div>
						</div>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command='logout'>退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div class="pointer" v-else @click="toUrl('/login')" style="margin-left: 9px;">
					<div class="flex">
						<div class="vipbg flex flex-c-c">登录</div>
					</div>
				</div>
			</div>
		</div>
		<div style="height: 62px;"></div>
	</div>
</template>

<script>
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import Utils from "@/jslibs/utils";
	export default {
		props: {
			tabIndex: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				tabs: ['首页', '课程', '培训', '我的'],
				loginUser: {
					member: {}
				}
			}
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
		},
		methods: {
			logout(e) {
				if (e == 'logout') {
					this.$router.push({
						path: '/login'
					})
					const firstLoginFlag = localStorage.getItem('firstLoginFlag_' + this.loginUser.phone)
					window.localStorage.clear()
					window.sessionStorage.clear()
					// 1. 获取当前域名下的所有Cookie
					const cookies = document.cookie.split('; ');

					// 2. 遍历每个Cookie并将其过期时间设置为过去，从而删除
					for (let i = 0; i < cookies.length; i++) {
						const cookie = cookies[i];
						// 将Cookie字符串在第一个等号处分割，以分离键和值
						const eqPos = cookie.indexOf('=');
						const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

						// 关键：删除时需要指定相同的路径(path)和域名(domain)
						// 将过期时间设置为1970年1月1日（Unix纪元起点），即立即过期
						document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
					}
					localStorage.setItem('firstLoginFlag_' + this.loginUser.phone, firstLoginFlag)
				}
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			toPage(index) {
				if (index == 0) {
					this.$router.push({
						path: '/index'
					})
				}
				if (index == 1) {
					this.$router.push({
						path: '/course'
					})
				}
				if (index == 2) {
					this.$router.push({
						path: '/training'
					})
				}
				if (index == 3) {
					this.$router.push({
						path: '/mine'
					})
				}
			},
			toUrl(path) {
				this.$router.push({
					path: path
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.topbg {
		width: 100%;
		height: 62px;
		background: #00A73C;
		border-radius: 0px 0px 0px 0px;
		position: fixed;
		z-index: 99;
		left: 0;
		top: 0;
		padding: 19px 34px;
	}

	.tabItemd,
	.tabItem {
		width: 89px;
		height: 62px;
		background: transparent;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #FFFFFF;
	}

	.tabItemd {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 600;
		font-size: 18px;
		color: #00A73C;
		background: #FFFFFF;
	}

	.znx {
		width: 22px;
		height: 22px;
		position: relative;

		.red {
			position: absolute;
			width: 7px;
			height: 7px;
			background: #FC5F5F;
			border-radius: 50%;
			right: 0;
			top: 0;
		}
	}

	.nickName {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
	}

	.vipbg {
		padding: 0 10px;
		height: 20px;
		background: #D7B155;
		border-radius: 4px 4px 4px 4px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
	}
</style>